import { render, staticRenderFns } from "./contestDetail.vue?vue&type=template&id=98f804b8&scoped=true"
import script from "./contestDetail.vue?vue&type=script&lang=js"
export * from "./contestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f804b8",
  null
  
)

export default component.exports